module.exports = __webpack_public_path__ + "img/th_kikk.1e716f77.jpg";